import styled from "styled-components";
import { Chip } from "@mui/material";
import FontStyle from "../styles/fontStyles";

type TagProps = {
  outlined?: boolean;
  props?: any;
  [key: string]: any;
};

const StyledChip = styled(Chip)(({ theme, variant }: any) => ({
  backgroundColor:
    variant === "outlined"
      ? (theme as any).palette.primary.main + 20
      : (theme as any).palette.secondary.main,
  ...FontStyle.medium12,
}));

function Tag({ outlined, ...props }: TagProps) {
  return (
    <StyledChip
      variant={outlined ? "outlined" : undefined}
      color="primary"
      {...props}
    />
  );
}

export default Tag;
